import { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import PreAdmissionDetailContainer from '../../components/pre-admission-detail-container/PreAdmissionDetailContainer';

class PreAdmissionDetail extends Component {
  render() {
    return (
      <div>
        <PreAdmissionDetailContainer preAdmissionId={this.props.match.params.id} />
      </div>
    );
  }
}

PreAdmissionDetail.propTypes = {
  match: PropTypes.object,
};

export default withRouter(PreAdmissionDetail);
